import { Button, EyeIcon, HiddenEyeIcon, Input, PasswordProps, VisuallyHidden } from '@postidigital/posti-components'
import React, { forwardRef, useState } from 'react'

// The library Password does not expose props for its visibility button.
export const Password = forwardRef<HTMLInputElement, PasswordProps & { id: string }>(function Password(
  { id, hideIconAriaLabel = 'Hide password', showIconAriaLabel = 'Show password', ...props },
  ref
) {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <>
      <Input
        autoCapitalize="none"
        autoComplete="current-password"
        spellCheck={false}
        {...props}
        id={id}
        ref={ref}
        type={isVisible ? 'text' : 'password'}
        rightTemplate={
          <Button
            id={`${id}_toggle_visibility`}
            type="button"
            aria-controls={id}
            aria-label={isVisible ? hideIconAriaLabel || 'Hide password' : showIconAriaLabel || 'Show password'}
            aria-pressed={isVisible}
            contentMode="secondary"
            isOnlyIcon
            leftIcon={isVisible ? HiddenEyeIcon : EyeIcon}
            onClick={() => setIsVisible((visible) => !visible)}
            size="xxxs"
          />
        }
      />
      <VisuallyHidden aria-live="polite">
        {isVisible ? 'Your password is visible' : 'Your password is hidden'}
      </VisuallyHidden>
    </>
  )
})
